import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '../../../common/components/Container/Container';
import Loading from '../../../common/components/Loading/Loading';
import MessagePanel from '../../../common/components/MessagePanel/MessagePanel';
import { Routes } from '../../../config/routes';
import FlowMode from '../../../providers/validation/FlowMode';
import { ValidationContext } from '../../../providers/ValidationContext';
import { FlowConfigContext } from '../../../providers/FlowConfigContext';
import withRouteAnalytics from '../../../services/analytics/withRouteAnalytics';
import { Screens } from '../../../services/analytics/screens';
import { GatekeeperNetworkServiceContext } from '../../../providers/GatekeeperNetworkService/GatekeeperNetworkServiceContext';

function UploadCompleteScreen(): JSX.Element {
  const navigate = useNavigate();
  const { initialized } = useContext(FlowConfigContext);
  const { waitForBackgroundProcessing, flowMode, getRouteForNextStep } = useContext(ValidationContext);
  const [loading, setLoading] = useState(true);
  const { gknServiceData } = useContext(GatekeeperNetworkServiceContext);

  // Switch out copy so on breakout mode we have platform-correct copy.
  const description =
    (gknServiceData?.constraints?.public?.proofOfPersonhood?.enableHandoverBreakoutFlow ?? false) === true
      ? 'screens.documentPass.uploadCompleted.descriptionMobileBreakoutMode'
      : 'screens.documentPass.uploadCompleted.descriptionMobile';

  const ensureUploadIsCompleted = async () => {
    const processingResult = await waitForBackgroundProcessing();
    setLoading(false);
    if (processingResult.isFailed()) {
      navigate(Routes.VALIDATION_ERROR);
    }
  };

  useEffect(() => {
    if (!initialized) {
      return;
    }

    ensureUploadIsCompleted();
  }, [initialized]);

  const onConfirm = async () => {
    const route = await getRouteForNextStep();
    if (route) navigate(route);
  };

  return (
    <>
      {loading && (
        <Container>
          <Loading />
        </Container>
      )}
      {!loading && flowMode === FlowMode.partial && (
        <MessagePanel
          title="screens.documentPass.uploadCompleted.title"
          description={description}
          dataTestId="UPLOAD_COMPLETED"
          showSupportLink={false}
        />
      )}
      {!loading && flowMode === FlowMode.handover && (
        <MessagePanel
          title="screens.documentPass.uploadCompleted.title"
          description="screens.documentPass.uploadCompleted.descriptionWeb"
          dataTestId="UPLOAD_COMPLETED"
          showSupportLink={false}
          buttonLabel="screens.documentPass.uploadCompleted.continueButton"
          onConfirm={onConfirm}
        />
      )}
    </>
  );
}
export default withRouteAnalytics(UploadCompleteScreen, Screens.DOCUMENT_UPLOAD_COMPLETE);
